import { system } from 'styled-system';

const borderRightStyle = system({
  borderRightStyle: {
    property: 'borderRightStyle',
  },
});

export default borderRightStyle;
